import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return (
      <div
        className="min-h-[60vh] flex items-center justify-center font-display text-2xl"
        style={{ color: "var(--rincon-text-muted)" }}
        data-testid="auth-loading"
      >
        Cargando...
      </div>
    );
  }
  if (!user || user === false) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
